import {styled} from '@material-ui/core'

export const Container = styled('div')({
  '& .swiper-pagination': {
    position: 'relative',
    margin: '15px 0 0 0',
  },
  '& .swiper-slide': {
    display: 'flex',
    height: 'auto',
  }
})
